"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
function StickyDragOverlay({ hint, className }) {
    return ((0, jsx_runtime_1.jsx)(Container, { className: className, role: "draggable", "data-e2e": 'StickyDragOverlay_Container', children: (0, jsx_runtime_1.jsx)(Hint, { "data-e2e": 'StickyDragOverlay_Hint', children: hint }) }));
}
exports.default = StickyDragOverlay;
const Container = styled_components_1.default.div `
  position: absolute;

  display: flex;
  align-items: center;
  justify-content: center;

  background: ${({ theme }) => theme.white_50};
`;
const Hint = styled_components_1.default.div `
  margin: auto;
  padding: 10px;

  color: ${({ theme }) => theme.whiteSecondary};

  font-size: 14px;

  background: ${({ theme }) => theme.gray};
  border-radius: 5px;
`;
